import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { useTranslation } from 'react-i18next'

export const Tabs = ({
  activeTab: [active, setActive] = [null, () => {}],
  tabs = ['Elements', 'Background', 'Settings'],
  ...props
}) => {
  const { t } = useTranslation()
  return (
    <Flex
      full
      align="center"
      justify="space-around"
      height="54px"
      borderBottom="1px solid"
      borderColor="gray4"
      {...props}
    >
      {tabs.map((tab) => (
        <Flex
          center
          height="100%"
          clickable
          onClick={() => setActive(tab)}
          key={tab}
          data-testid={`menu-tab-${tab.toLowerCase()}`}
        >
          <Text
            size="12px"
            weight={active === tab ? '500' : '400'}
            color={active === tab ? 'almostBlack' : 'gray2'}
          >
            {t(`editor.tabs.${tab.toLowerCase()}.title`)}
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}

export default Tabs
